import IosShareIcon from "@mui/icons-material/IosShare";

export const resources = {
  isMenu: true,
  icon: <IosShareIcon />,
  //   name: PublicationServicePath + PUBLICATIONS,
  title: "Генерирай файл за Нацид",
  recordRepresentation: "title",
  //   list: <ListEmployeePublications />,
  //   show: <ShowEmployeePublication />,
};
